<template>
  <div>
    <div 
      class="d-flex justify-content-start align-items-center" 
      style="margin-left:10px" 
      v-for="(item, index) of uniqueSigners" 
      :key="item.id"
    >
      <span class="font-primary">{{ index + 1 + '.' }}</span>
      <span class="font-primary" style="width: 220px;">{{ item.signerName }}</span>
      <span class="font-primary" style="width: 350px;">{{ item.note }}</span>
      <i 
        class="font-primary" 
        style="margin-top:4px;"  
        :class="item.status === 1 ? 'fa-solid fa-check' : item.status === 2 ? 'fa-solid fa-ban' : 'fa-solid fa-clock'"
        :style="item.status === 1 ? 'color:green' : item.status === 2 ? 'color:red' : 'color:orange'"
      ></i>
      &nbsp;<span class="font-primary">{{ item.status === null ? 'Gözləmədədir' : item.statusDateStr }}</span>
    </div>
  </div>
</template>

<script>
import {
  GetActApproval,
} from "src/services/claim";
export default {
  props: {
    value: Number,
  },
  data() {
    return {
      id: this.value,
      signers: []
    };
  },
  computed: {
    uniqueSigners() {
      return this.signers.filter((item, index, self) =>
        index === 0 || item.id !== self[index - 1].id
      ).map((item, index) => ({
        ...item,
        rowNumber: index + 1
      }));
    },
  },
  watch: {
    value() {
      this.id = this.value;
      this.getActApproval();
    },
  },
  methods: {
    refreshSigners() {
      this.getActApproval();
    },
    getActApproval() {
      GetActApproval(this.id).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.signers = response.data.data;
        }
      });
    },
  },
  mounted() {
    this.getActApproval();
  },
};
</script>

<style lang="scss" scoped>
.pd {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>